import React, { Component } from 'react';
import PropTypes from 'prop-types';
import strings from '../../Globalization/index';
import RoleModuleTable from '../../AppGrid/RoleModuleTable';

class RoleModuleList extends Component {
    render() {
        return (
            <div id="wrapper ibox float-e-margins">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-10 default-color">
                        <h2>RoleModule</h2>
                        <ol className="breadcrumb">
                            <li>
                                <span>{strings.Admin}</span>
                            </li>
                            <li className="active">
                                <span>RoleModule</span>
                            </li>
                        </ol>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row wrapper ibox-content float-e-margins">
                        <RoleModuleTable scope={this} title='RoleModule' />
                    </div>
                </div>
            </div>
        );
    }
}

RoleModuleList.propType = {
    router: PropTypes.object.isRequired
};
export default RoleModuleList